var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('common-breadcrumb'),_c('div',{staticClass:"table-wrap"},[_c('div',{staticClass:"top-tab flex-space-between"},[_c('div',{staticClass:"tab-text"},[_vm._v("我的申请")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.refresh}},[_vm._v("刷新")])],1),_c('applicationMain',{ref:"apply"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }